import PropTypes from 'prop-types';

var propTypes = {
    value: PropTypes.number.isRequired,
    min: PropTypes.number.isRequired,
    max: PropTypes.number.isRequired,
    onChange: PropTypes.func.isRequired,
    name: PropTypes.string,
    disabled: PropTypes.bool,
    leftLabel: PropTypes.node,
    rightLabel: PropTypes.node,
    className: PropTypes.string,
    step: PropTypes.number,
    withBackground: PropTypes.bool,
};
var defaultProps = {
    disabled: false,
    withBackground: false,
};

export { defaultProps, propTypes };
